import { Link } from "react-router-dom";
import { Problems } from "@/components/home/Problems";
import { TrustPromise } from "@/components/home/TrustPromise";
import { AstraWordmark } from "@/components/shared/AstraWordmark";
import { ContactFoot } from "@/components/shared/ContactFoot";
import { ContentImage } from "@/components/shared/ContentImage";
import { siteConfig } from "@/config/site";
import { siteAssetPaths } from "@/lib/assets";
import { useContact } from "@/context/ContactContext";
import { createIntakeContext } from "@/lib/intakeContext";

export function HomePage() {
  const { openIntakeContact } = useContact();
  const openHeaderIntake = () =>
    openIntakeContact(createIntakeContext({ source: "home" }));
  const openFooterIntake = () =>
    openIntakeContact(createIntakeContext({ source: "footer" }));

  return (
    <div className="pb-2">
      <div className="flex items-center justify-between px-5 pb-0 pt-3.5">
        <AstraWordmark />
        <button
          type="button"
          onClick={openHeaderIntake}
          className="flex h-[38px] items-center gap-1.5 rounded-pill border border-[var(--line)] bg-paper px-3.5 text-[13px] font-semibold text-ink-900"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
            <path
              d="M2 3.5h10v6H5l-3 2.5v-8.5z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
          </svg>
          联系管家
        </button>
      </div>

      <section className="px-5 pb-6 pt-5">
        <div className="relative mb-5">
          <ContentImage
            src={siteAssetPaths.hero()}
            alt="新加坡 · 滨海湾天际线"
            height={220}
            photoDim="coral"
            photoLabel="新加坡 · 滨海湾天际线"
            className="rounded-xl"
          />
          <div className="absolute bottom-3.5 left-3.5 inline-flex items-center gap-1.5 rounded-pill bg-white/90 px-3 py-1.5 text-[11.5px] font-semibold text-coral-700 backdrop-blur-sm">
            <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-coral-500" />
            {siteConfig.heroTagline}
          </div>
        </div>

        <h1 className="text-[34px] font-bold leading-[1.15] tracking-[-0.025em] text-ink-900 xs:text-[38px]">
          新加坡留学,
          <br />
          <span className="text-forest-900">有人替你安家。</span>
        </h1>
        <p className="mt-4 text-[15px] leading-[1.7] text-ink-600">
          人在国内,房子还远在5,000公里外。我们替你看房、指导签约、把关合同——从拿到offer那天起,陪你到搬进新家，管家全程陪同，保驾护航新加坡安家，真正的花小钱办大事。
        </p>

        <div className="mt-6 flex flex-col gap-2.5">
          <Link
            to="/schools"
            className="btn-primary flex h-[60px] flex-col gap-0.5 py-0"
          >
            <span className="flex items-center gap-2">
              查看找房攻略
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
                <path
                  d="M2.5 7h9M8 3.5L11.5 7 8 10.5"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="text-[11.5px] font-medium opacity-85">为你匹配房源</span>
          </Link>
          <Link to="/service" className="btn-secondary">
            了解我们的服务
          </Link>
        </div>
      </section>

      <Problems />
      <TrustPromise />
      <ContactFoot onContact={openFooterIntake} />
    </div>
  );
}
